import Decimal from '@st/decimal'
import { useBonusesDeps } from '../useDeps'

interface GetBonusInfoReturn {
  totalBonusClaimedAmount: ComputedRef<string>
  isZeroTotalAmount: ComputedRef<boolean>
}

export function useGetBonusInfo(): GetBonusInfoReturn {
  const { data: bonusesInfo } = useStFetch('/bonus/info/get', {
    method: 'post',
  })

  const { appCurrencyCode } = useBonusesDeps()
  const { format: formatCurrency } = useCurrencyFormatter({
    currency: appCurrencyCode.value,
  })

  const totalBonusClaimedAmount = computed(() =>
    formatCurrency(bonusesInfo.value?.totalBonusClaimedAmount ?? 0),
  )

  const isZeroTotalAmount = computed(() =>
    new Decimal(bonusesInfo.value?.totalBonusClaimedAmount ?? 0).isZero(),
  )

  return {
    totalBonusClaimedAmount,
    isZeroTotalAmount,
  }
}
